export var createFormInput = function (name, value) {
    var input = document.createElement("INPUT");
    input.setAttribute("type", "hidden");
    input.setAttribute("name", name);
    input.setAttribute("value", value);
    return input;
};
export default (function (action, inputs, target) {
    var form = document.createElement("form");
    form.setAttribute("method", "POST");
    form.setAttribute("action", action);
    if (target) {
        form.setAttribute("target", target);
    }
    Object.keys(inputs).forEach(function (key) {
        form.appendChild(createFormInput(key, inputs[key]));
    });
    document.body.appendChild(form);
    return form;
});
